import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Webservices } from '../../constants/routes/webservices.constant';
import { AbstractHttpService, Response } from './abstract-http.service';
import { BootstrapDto } from '../../models/dto/bootstrap-dto';

@Injectable({
  providedIn: 'root',
})
export class BootstrapHttpService extends AbstractHttpService {
  public bootstrap(): Observable<BootstrapDto | null> {
    return this.get<BootstrapDto>(Webservices.bootstrap, {
      response: Response.json,
    });
  }
}
